import { Button } from '@warp-ds/react';
import { useState } from 'react';
import { useConfig } from 'shared/config/ConfigContext';
import { safeFormatISODate } from 'shared/util/datetime-fns';
import { queryString } from 'shared/util/query';
import { PriceOverview } from '@/components/priceOverview/PriceOverview';
import { useObject } from '@/hooks/useObject';
import { usePreview } from '@/hooks/usePreview';
import { replacePropsWithPreview } from '@/scenes/objectPage/utils';
import { CalendarSelectGuests } from './CalendarSelectGuests';

export type TjvrCalendarContactFormProps = {
    startDate: Date | null;
    endDate: Date | null;
    numGuests: number | null;
};

export const TjvrCalendarContactForm = ({ startDate, endDate, numGuests }: TjvrCalendarContactFormProps) => {
    const isPreview = usePreview();
    const objectData = useObject();
    const { contextPath } = useConfig();
    const { adId } = objectData;

    const [numberOfGuests, setNumberOfGuests] = useState(numGuests?.toString() ?? 'Velg antall');
    const [missingDatesError, setMissingDatesError] = useState(false);
    const [missingGuestsError, setMissingGuestsError] = useState(false);
    const [isInProgress, setInProgress] = useState(false);

    const hasDates = startDate != null && endDate != null;
    const showSelectGuests = hasDates;
    const showPrice = hasDates && numberOfGuests !== 'Velg antall';

    const renderErrors = () => {
        let errorText = '';
        if (!hasDates && missingDatesError) {
            errorText = 'Velg datoene du ønsker å leie før du går videre';
        } else if (hasDates && numberOfGuests === 'Velg antall' && missingGuestsError) {
            errorText = 'Velg antall gjester før du går videre';
        }
        return <div className="text-12 text-center s-text-negative">{errorText}</div>;
    };

    return (
        <>
            {showSelectGuests && (
                <CalendarSelectGuests
                    numberOfBeds={objectData.noOfBeds}
                    onChange={(event) => setNumberOfGuests(event.target.value)}
                    numberOfGuests={numberOfGuests}
                />
            )}
            {showPrice && (
                <PriceOverview
                    adId={adId}
                    startDate={startDate}
                    endDate={endDate}
                    numberOfGuests={Number(numberOfGuests)}
                    cleaningChoice={null}
                />
            )}
            <Button
                primary
                fullWidth
                disabled={objectData.status?.isPaused}
                className={`my-16 ${isInProgress ? 'in-progress' : ''}`}
                href={`${contextPath}/opprettforesporsel/${queryString({
                    finnkode: adId,
                    startDate: safeFormatISODate(startDate),
                    endDate: safeFormatISODate(endDate),
                    guests: numberOfGuests,
                })}`}
                {...replacePropsWithPreview(
                    {
                        onClick: (e) => {
                            if (!hasDates) {
                                e.preventDefault();
                                setMissingDatesError(true);
                            } else if (numberOfGuests === 'Velg antall') {
                                e.preventDefault();
                                setMissingGuestsError(true);
                            } else {
                                setInProgress(true);
                                // Workaround for sticky progress bar when command-clicking the link:
                                setTimeout(() => {
                                    setInProgress(false);
                                }, 3000);
                            }
                        },
                    },
                    isPreview,
                )}>
                Gå videre
            </Button>
            {renderErrors()}
            {showPrice && <div className="text-12 text-center s-text-subtle">Du betaler ingenting ennå</div>}
        </>
    );
};
